export const internalLinks = {}
export const externalLinks = {
  lifestyleApp: "https://lifestyle.personalgdm.com",
  outcomesApp: "https://outcomes.personalgdm.com",
  mchri: "https://www.monash.edu/medicine/sphpm/mchri",
  monashHealth: "https://monashhealth.org",
  mchriFacebook: "https://www.facebook.com/monashmchri/",
  MonashUniversity: "https://www.monash.edu/",
}
